export default __webpack_public_path__ + "static/media/TestExecute-Logo.bd8f9cee.svg";